import React, {Component, createRef, RefObject} from "react";
import {Button} from "@material-ui/core";
import {logPageView} from 'services/analytics';
import {RouteComponentProps} from 'react-router';
import RouteURLs from 'RouteURLs';
import AuthLayout from 'layouts/Authentication';
import './index.scss';
import Carousel from 'components/Carousel';
import CurationToolIcon from 'assets/img/register/curation-tool-icon.svg';
import VirtualTourIcon from 'assets/img/register/virtual-tour-icon.svg';
import SupportIcon from 'assets/img/register/support-icon.svg';
import RegisterForm from 'components/auth/RegisterForm';
import {loadUser} from "services/auth";
import {getUserDefaultRoute} from "util/routing";

export default class RegisterPage extends Component<RouteComponentProps> {
  private readonly carousel: RefObject<Carousel> = createRef();

  componentDidMount(): void {
    logPageView(RouteURLs.REGISTER, 'Sign Up');
  }

  onLogin = () => {
    this.props.history.push(RouteURLs.LOGIN);
  };

  onRegistered = () => {
    loadUser().then(
      user => this.props.history.push(getUserDefaultRoute(user)),
      () => this.props.history.push(RouteURLs.DASHBOARD)
    );
  };

  onNextSideBarItemClick = () => {
    if(this.carousel.current) {
      this.carousel.current.move(1);
    }
  };

  renderSidebarCarousel() {
    return <Carousel ref={this.carousel} showPagination={true} items={[
      <div>
        <img src={CurationToolIcon} alt="" />
        <p>Access our FREE curation tool
          and build as many spaces as you like</p>
        <Button className="next" onClick={this.onNextSideBarItemClick}>Next</Button>
      </div>,
      <div>
        <img src={VirtualTourIcon} alt="" />
        <p>Instantly view your space with our
            Virtual Tour tool</p>
        <Button className="next" onClick={this.onNextSideBarItemClick}>Next</Button>
      </div>,
      <div>
        <img src={SupportIcon} alt="" />
        <p>Gain access to our support team,
          who are dedicated to helping you
          bring your dream to life.</p>
        <Button className="next" onClick={this.onNextSideBarItemClick}>Next</Button>
      </div>,

    ]}/>;
  }
    
  render() {
    return (
      <AuthLayout id="register-page" sidebarChildren={this.renderSidebarCarousel()}>
        <RegisterForm onRegistered={this.onRegistered} onLogin={this.onLogin} />
      </AuthLayout>
    );
  }
}
